<template>
    <section>
        <div class="module-container">
            <div class="templates-list">
                <div class="templates-list__header">
                    <span>Listagem de templates</span>
                    <button class="btn btn-success" @click="createNewTemplate()"><i class="fas fa-plus"></i> Criar novo
                        template</button>
                    <button class="btn btn-outline-primary" @click="createNewTemplate(), getTemplates()"
                        title="Atualizar listagem"><i class="fas fa-sync"></i></button>
                </div>
                <chat-queues-multiselect v-model="selectedQueues" :useIds="true"
                    :allSelected="true"></chat-queues-multiselect>
                <div v-for="template in filteredTemplates" :key="template.id">
                    <div class="templates-list__item" :class="{ 'selected': selectedTemplate.id === template.id }"
                        @click="selectTemplate(template)">
                        <span class="item-name">{{ template.name }}</span>
                        <span class="item-category">{{ parseCategory(template.category) }}</span>
                        <span class="status" :class="{
                            'approved': template.status === 'APPROVED',
                            'pending': template.status === 'PENDING',
                            'rejected': template.status === 'REJECTED'
                        }">
                            {{ parseStatus(template.status) }}
                        </span>
                        <div class="badges-container">
                            <span v-if="template.templateType === 'CAMPANHA'"
                                class="badge type-badge type-badge--campanha">
                                <i class="fas fa-bullhorn"></i> Campanha
                            </span>
                            <span v-else class="badge type-badge type-badge--geral">
                                <i class="fas fa-comments"></i> Geral
                            </span>
                            <template v-if="template.queues && template.queues.length">
                                <span v-for="(queue, index) in template.queues" :key="queue" v-if="index < 3"
                                    class="badge queue-badge">
                                    {{ getQueueName(queue) }}
                                </span>
                                <span v-if="template.queues.length > 3" class="tooltip-container">
                                    <strong>+{{ template.queues.length - 3 }}</strong>
                                    <span class="tooltip-text">
                                        <div class="tooltip-item"
                                            v-for="(name, index) in remainingQueues(template.queues)" :key="index">
                                            {{ name }}
                                        </div>
                                    </span>
                                </span>
                            </template>
                            <span v-else class="badge queue-badge">Geral</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="template-preview">
                <div v-if="selectedTemplate" class="template-preview__content">
                    <div v-if="selectedTemplate.status === 'PENDING'" class="alert alert-warning">
                        <span>Não é possível editar um template que está pendente de aprovação</span>
                    </div>
                    <div class="template-preview__section">
                        <span>Nome do template: </span>
                        <input type="text" placeholder="Digite o nome do template..." class="form-control"
                            v-model="selectedTemplate.name"
                            :disabled="selectedTemplate.status === 'PENDING' || selectedTemplate.status === 'APPROVED'">
                    </div>
                    <div class="template-preview__section">
                        <span>Filas: </span>
                        <chat-queues-multiselect v-if="selectedTemplate.queues !== undefined"
                            v-model="selectedTemplate.queues" :useIds="true"></chat-queues-multiselect>
                    </div>
                    <div class="template-preview__section">
                        <span>Tipo do template</span>
                        <label>Defina se este template é de uso geral ou destinado a campanhas</label>
                        <div class="template-type-selector">
                            <div class="type-option" :class="{
                                'type-option--active': selectedTemplate.templateType === 'GERAL',
                                'type-option--disabled': selectedTemplate.status === 'PENDING'
                            }"
                                @click="selectedTemplate.status !== 'PENDING' && (selectedTemplate.templateType = 'GERAL')">
                                <i class="fas fa-comments"></i>
                                <span>Geral</span>
                            </div>
                            <div class="type-option" :class="{
                                'type-option--active': selectedTemplate.templateType === 'CAMPANHA',
                                'type-option--disabled': selectedTemplate.status === 'PENDING'
                            }"
                                @click="selectedTemplate.status !== 'PENDING' && (selectedTemplate.templateType = 'CAMPANHA')">
                                <i class="fas fa-bullhorn"></i>
                                <span>Campanha</span>
                            </div>
                        </div>
                    </div>
                    <div class="template-preview__section">
                        <span>Informações</span>
                        <label>Categoria, idioma e status do template</label>
                        <div class="template-info">
                            <select class="form-control" v-model="selectedTemplate.category"
                                :disabled="(selectedTemplate.status === 'PENDING' || selectedTemplate.status === 'APPROVED')">
                                <option value="" selected disabled>Escolha a categoria...</option>
                                <option value="MARKETING">Marketing</option>
                                <option value="UTILITY">Utilidade</option>
                            </select>
                            <select class="form-control" v-model="selectedTemplate.language"
                                :disabled="(selectedTemplate.status === 'PENDING' || selectedTemplate.status === 'APPROVED')">
                                <option value="" selected disabled>Escolha o idioma...</option>
                                <option value="pt_BR">Português (Brasil)</option>
                                <option value="en_US">Inglês (EUA)</option>
                            </select>
                            <div class="status">
                                <span>Status: </span>
                                <span :class="{
                                    'approved': selectedTemplate.status === 'APPROVED',
                                    'pending': selectedTemplate.status === 'PENDING',
                                    'rejected': selectedTemplate.status === 'REJECTED'
                                }">{{ parseStatus(selectedTemplate.status) }}</span>
                            </div>
                            <div class="alert alert-danger" v-if="rejectionReason">
                                <span>Motivo da rejeição: {{ rejectionReason }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="template-preview__section">
                        <span>Cabeçalho (Opcional)</span>
                        <label>Adicione um título ou escolha qual tipo de mídia você usará para esse cabeçalho</label>
                        <div class="template-header">
                            <select class="form-control" v-model="templateHeader.format"
                                :disabled="(selectedTemplate.status === 'PENDING')">
                                <option value="" selected>Nenhum</option>
                                <option value="TEXT">Texto</option>
                            </select>
                            <input v-if="templateHeader.format === 'TEXT'" class="form-control"
                                v-model="templateHeader.text" :disabled="(selectedTemplate.status === 'PENDING')" />
                        </div>
                    </div>
                    <div class="template-preview__section">
                        <span>Corpo</span>
                        <label>Insira o texto da sua mensagem no idioma selecionado</label>
                        <custom-editor @updatedVariable="updatedVariables => variables = updatedVariables"
                            @writing="writingText" :removeVariable="removedVariable"
                            :templateVariables="templateVariables" :bodyText="templateBody.text"
                            :selectingTemplate="selectedTemplateCheck"
                            :disabled="(selectedTemplate.status === 'PENDING')" :refreshingTemplate="refreshTemplate" />
                        <div class="body-char-counter" :class="{ 'body-char-counter--warn': bodyExceedsLimit }">
                            <span v-if="templateButtons.length > 0">
                                <i class="fas fa-info-circle"></i>
                                Templates com botões têm limite de <strong>1024 caracteres</strong> no corpo.
                                <strong :class="{ 'text-danger': bodyExceedsLimit, 'text-success': !bodyExceedsLimit }">
                                    {{ templateBodyCharCount }}/1024
                                </strong>
                            </span>
                            <span v-else class="text-muted">
                                {{ templateBodyCharCount }} caracteres
                            </span>
                        </div>
                    </div>

                    <!-- BOTÕES -->
                    <div class="template-preview__section">
                        <span>Botões (Opcional)</span>
                        <label>Adicione até 3 botões de resposta rápida</label>
                        <div v-for="(btn, index) in templateButtons" :key="index" class="btn-row">
                            <span class="btn-index">{{ index + 1 }}.</span>
                            <input type="text" class="form-control" placeholder="Texto do botão (máx. 25 caracteres)"
                                maxlength="25" v-model="btn.text" :disabled="selectedTemplate.status === 'PENDING'" />
                            <button class="btn btn-danger btn-sm" @click="removeButton(index)"
                                :disabled="selectedTemplate.status === 'PENDING'" title="Remover botão">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                        <button v-if="templateButtons.length < 3" class="btn-add-button" @click="addButton"
                            :disabled="selectedTemplate.status === 'PENDING'">
                            <i class="fas fa-plus"></i> Adicionar botão
                        </button>
                    </div>

                    <div v-if="variables.filter(el => el.id !== null).length" class="template-preview__section">
                        <span>Variáveis</span>
                        <label>Parâmetros a serem enviados no corpo do template</label>
                        <div v-for="variable in variables.filter(el => el.id !== null)" :key="variable.id"
                            class="variables-container">
                            <div v-if="variable.id" class="variable-item">
                                <span>{{ variable.id }}</span>
                                <input class="form-control" v-model="variable.text"
                                    :disabled="(selectedTemplate.status === 'PENDING')" />
                                <button class="btn btn-danger" @click="removeVariable(variable.id)"
                                    :disabled="(selectedTemplate.status === 'PENDING')">Remover</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div v-if="selectedTemplate.existing" class="action-buttons">
                        <button class="btn btn-danger" @click="deleteTemplate"
                            :disabled="(selectedTemplate.status === 'PENDING')">
                            <i class="fas fa-trash"></i> Excluir
                        </button>
                        <button v-if="onlyLocalChanged" class="btn btn-secondary" @click="saveLocalSettings"
                            title="Salva filas e tipo sem reenviar o template para aprovação da Meta">
                            <i class="fas fa-tag"></i> Salvar filas e tipo
                        </button>
                        <button v-if="!onlyLocalChanged" class="btn btn-primary" @click="editTemplate"
                            :disabled="selectedTemplate.status === 'PENDING'"
                            title="Salva o conteúdo do template e reenvia para aprovação da Meta">
                            <i class="fas fa-save"></i> Salvar
                        </button>
                    </div>
                    <div v-else class="action-buttons">
                        <button class="btn btn-danger" @click="createNewTemplate"><i class="fas fa-times"></i>
                            Limpar</button>
                        <button class="btn btn-primary" @click="createTemplate"
                            :disabled="selectedTemplate.status === 'PENDING'">
                            <i class="fas fa-plus"></i> Criar
                        </button>
                    </div>
                </div>
            </div>
            <div class="template-message-preview">
                <div class="template-message-preview__header">
                    <span>Preview do template</span>
                </div>
                <div class="preview-slot">
                    <div v-if="(templateHeader.format === 'TEXT' && templateHeader.text !== '') || (bodyText.trim() !== '')"
                        class="message-item">
                        <div v-if="templateHeader.text" class="message-header">
                            <span>{{ templateHeader.text }}</span>
                        </div>
                        <div class="message-body">
                            <span class="body-preview-text" v-html="bodyText"></span>
                        </div>
                        <!-- Preview dos botões -->
                        <div v-if="templateButtons.length" class="message-buttons">
                            <div v-for="(btn, i) in templateButtons" :key="i" class="message-button-item">
                                {{ btn.text || 'Botão ' + (i + 1) }}
                            </div>
                        </div>
                    </div>
                    <div v-else class="alert alert-warning m-2">
                        <span>Selecione um template para visualizar, ou crie seu template</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" tabindex="-1" role="dialog" id="loading-modal" data-backdrop="static"
            data-keyboard="false" :class="{ 'modal-showing': loading }">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body">
                        <b-spinner small variant="primary" />
                        <span>Carregando. Por favor, aguarde...</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Swal from 'sweetalert2';
import chatqueuesMultiselect from '../../components/filters/ChatQueuesMultiselect.vue'

export default {
    name: 'Templates',
    components: { chatqueuesMultiselect },
    data() {
        return {
            customToolbar: [["bold", "italic"]],
            allTemplates: [],
            selectedTemplate: {
                id: null,
                existing: false,
                new: false,
                name: '',
                category: '',
                language: '',
                status: '',
                components: [],
                queues: [],
                templateType: 'GERAL'
            },
            templateHeader: {
                type: 'HEADER',
                format: '',
                text: '',
                media: '',
                example: {}
            },
            templateBody: {
                type: 'BODY',
                text: '',
                media: '',
                example: {}
            },
            templateButtons: [],
            bodyText: '',
            variables: [],
            templateVariables: [],
            removedVariable: null,
            oldText: '',
            oldRawText: '',
            selectedTemplateCheck: false,
            refreshTemplate: false,
            uploadedFile: null,
            uploadedFileId: '',
            loading: false,
            rejectionReason: '',
            headerMedia: null,
            dbTemplates: [],
            queuesList: [],
            selectedQueues: [],
            // Snapshot do estado ao abrir o template — para detectar tipo de mudança
            originalSnapshot: {
                queues: [],
                templateType: 'GERAL',
                bodyText: '',
                headerFormat: '',
                headerText: '',
                buttons: []
            }
        }
    },
    async mounted() {
        await this.getQueues();
        await this.getTemplates();
    },
    computed: {
        filteredTemplates() {
            if (!this.selectedQueues.length) return this.allTemplates;
            return this.allTemplates.filter(template =>
                template.queues.some(queue => this.selectedQueues.includes(queue))
            );
        },
        templateBodyCharCount() {
            if (!this.oldRawText) return 0;
            return this.oldRawText.replace(/<[^>]+>/g, '').length;
        },
        bodyExceedsLimit() {
            return this.templateButtons.length > 0 && this.templateBodyCharCount > 1024;
        },
        // Detecta se apenas filas/tipo mudaram (sem alteração de conteúdo)
        onlyLocalChanged() {
            const snap = this.originalSnapshot;
            const queuesChanged =
                JSON.stringify([...(this.selectedTemplate.queues || [])].sort()) !==
                JSON.stringify([...snap.queues].sort());
            const typeChanged = this.selectedTemplate.templateType !== snap.templateType;
            const bodyChanged = this.oldText !== snap.bodyText;
            const headerFormatChanged = this.templateHeader.format !== snap.headerFormat;
            const headerTextChanged = this.templateHeader.text !== snap.headerText;
            const buttonsChanged =
                JSON.stringify(this.templateButtons.map(b => b.text)) !==
                JSON.stringify(snap.buttons);
            const contentChanged = bodyChanged || headerFormatChanged || headerTextChanged || buttonsChanged;
            const localChanged = queuesChanged || typeChanged;
            return localChanged && !contentChanged;
        },
        contentChanged() {
            const snap = this.originalSnapshot;
            const bodyChanged = this.oldText !== snap.bodyText;
            const headerFormatChanged = this.templateHeader.format !== snap.headerFormat;
            const headerTextChanged = this.templateHeader.text !== snap.headerText;
            const buttonsChanged =
                JSON.stringify(this.templateButtons.map(b => b.text)) !==
                JSON.stringify(snap.buttons);
            return bodyChanged || headerFormatChanged || headerTextChanged || buttonsChanged;
        }
    },
    methods: {
        async getQueues() {
            await axios.get('/listQueueChat').then(({ data }) => {
                this.queuesList = data;
            }).catch(error => console.log(error));
        },
        getQueueName(id) {
            if (!this.queuesList.length) return '';
            const find = this.queuesList.find(el => el.id === id);
            return find ? find.name : 'Não identificado';
        },
        remainingQueues(queues) {
            return queues.slice(3).map(id => this.getQueueName(id));
        },
        validateForm() {
            if (!this.selectedTemplate.name) {
                Swal.fire({ title: 'Erro ao criar template', text: 'O nome do template não pode estar vazio', type: "error", showConfirmButton: true });
                return false;
            }
            if (this.bodyText.trim() === '') {
                Swal.fire({ title: 'Erro ao criar template', text: 'O corpo do template não pode estar vazio', type: "error", showConfirmButton: true });
                return false;
            }
            if (this.templateHeader.format === 'TEXT' && !this.templateHeader.text) {
                Swal.fire({ title: 'Erro ao criar template', text: 'O cabeçalho do template não pode estar vazio', type: "error", showConfirmButton: true });
                return false;
            }
            if (!this.selectedTemplate.category) {
                Swal.fire({ title: 'Erro ao criar template', text: 'É obrigatório selecionar a categoria do template', type: "error", showConfirmButton: true });
                return false;
            }
            if (!this.selectedTemplate.language) {
                Swal.fire({ title: 'Erro ao criar template', text: 'É obrigatório selecionar o idioma do template', type: "error", showConfirmButton: true });
                return false;
            }
            if (this.templateButtons.length > 0 && this.templateBodyCharCount > 1024) {
                Swal.fire({
                    title: 'Corpo do template muito longo',
                    html: `Templates com botões têm limite de <strong>1024 caracteres</strong> no corpo.<br>Seu texto tem <strong>${this.templateBodyCharCount}</strong> caracteres.<br>Reduza em <strong>${this.templateBodyCharCount - 1024}</strong> caracteres para continuar.`,
                    type: "error",
                    showConfirmButton: true
                });
                return false;
            }
            return true;
        },
        addButton() {
            if (this.templateButtons.length >= 3) return;
            this.templateButtons.push({ text: '' });
        },
        removeButton(index) {
            this.templateButtons.splice(index, 1);
        },
        createObjectURL(file) {
            return URL.createObjectURL(file);
        },
        async getTemplates() {
            this.dbTemplates = await axios.post('/getDbTemplates', { queues_ids: [] }).then(({ data }) => data);
            const exampleTemplates = [
                'sample_movie_ticket_confirmation',
                'sample_flight_confirmation',
                'sample_issue_resolution',
                'sample_shipping_confirmation',
                'sample_happy_hour_announcement',
                'hello_world',
                'sample_purchase_feedback'
            ];
            axios.get(`https://api.advancemanagement.com.br:${process.env.MIX_WEBHOOK_PORT}/get_template_list`).then(async ({ data }) => {
                if (data && data.length) {
                    data.map(el => {
                        const dbFind = this.dbTemplates.find(temp => temp.template_id === el.id);
                        if (dbFind) {
                            el.queues = dbFind.queues_ids ? JSON.parse(dbFind.queues_ids) : [];
                            el.templateType = dbFind.template_type || 'GERAL';
                        } else {
                            el.queues = [];
                            el.templateType = 'GERAL';
                        }
                    });
                    const filteredTemplates = data.filter(el => !exampleTemplates.includes(el.name));
                    this.allTemplates = filteredTemplates;
                    await this.processTemplates(filteredTemplates, false);
                }
            });
        },
        selectTemplate(template) {
            this.getTemplateInfo(template.id);
            this.selectedTemplate = { ...template };
            this.selectingTemplate();
            this.bodyText = '';
            this.uploadedFile = null;
            this.uploadedFileId = '';
            this.headerMedia = null;
            this.templateButtons = [];
            this.templateHeader = { type: 'HEADER', format: '', text: '', example: {} };
            this.templateBody = { type: 'BODY', text: '', media: '', example: {} };
            this.$set(this.templateBody, 'text', '');
            if (!this.selectedTemplate.queues) this.$set(this.selectedTemplate, 'queues', []);
            if (!this.selectedTemplate.templateType) this.$set(this.selectedTemplate, 'templateType', 'GERAL');
            template.components.forEach((component) => {
                switch (component.type) {
                    case 'HEADER':
                        this.templateHeader = component;
                        break;
                    case 'BODY':
                        this.templateBody = component;
                        break;
                    case 'BUTTONS':
                        this.templateButtons = component.buttons
                            ? component.buttons.map(b => ({ text: b.text || '' }))
                            : [];
                        break;
                    default:
                        break;
                }
            });
            this.selectedTemplate.existing = true;
            this.selectedTemplate.new = false;
            // Salva snapshot do estado original para detectar tipo de alteração
            this.$nextTick(() => {
                this.originalSnapshot = {
                    queues: [...(this.selectedTemplate.queues || [])],
                    templateType: this.selectedTemplate.templateType || 'GERAL',
                    bodyText: this.oldText,
                    headerFormat: this.templateHeader.format,
                    headerText: this.templateHeader.text,
                    buttons: this.templateButtons.map(b => b.text)
                };
            });
            this.getTemplateVariables();
        },
        selectingTemplate() {
            this.selectedTemplateCheck = true;
            setTimeout(() => { this.selectedTemplateCheck = false; }, 50);
        },
        refreshingTemplate() {
            this.refreshTemplate = true;
            setTimeout(() => { this.refreshTemplate = false; }, 0);
        },
        createNewTemplate() {
            this.rejectionReason = '';
            this.templateVariables = [];
            this.templateButtons = [];
            this.refreshingTemplate();
            this.bodyText = '';
            this.oldText = '';
            this.oldRawText = '';
            this.uploadedFile = null;
            this.uploadedFileId = '';
            this.headerMedia = null;
            this.originalSnapshot = { queues: [], templateType: 'GERAL', bodyText: '', headerFormat: '', headerText: '', buttons: [] };
            this.selectedTemplate = {
                id: null,
                existing: false,
                new: true,
                name: '',
                category: '',
                language: '',
                status: '',
                components: [],
                queues: [],
                templateType: 'GERAL'
            };
            this.templateHeader = { type: 'HEADER', format: '', text: '', media: '', example: {} };
            this.templateBody = { type: 'BODY', text: '', media: '', example: {} };
        },
        getTemplateVariables(refreshing = false) {
            this.templateVariables = [];
            const bodyVariables = this.templateBody.example;
            if (!bodyVariables) return this.bodyText = this.templateBody.text;
            if (Object.keys(bodyVariables).length) {
                if (bodyVariables.body_text.length) {
                    bodyVariables.body_text[0].forEach((text, index) => {
                        this.templateVariables.push({ id: this.parseVariable(index + 1), text: text });
                        if (refreshing) {
                            this.bodyText = this.templateBody.text.replace(this.parseIndex(this.parseVariable(index + 1)), text);
                        } else {
                            this.bodyText = this.bodyText.replace(this.parseVariable(index + 1), text);
                        }
                    });
                }
            }
        },
        removeVariable(variableId) {
            this.removedVariable = variableId;
            setTimeout(() => { this.removedVariable = null; }, 50);
        },
        parseVariable(index) {
            if (index === 1) return '1️⃣';
            if (index === 2) return '2️⃣';
            if (index === 3) return '3️⃣';
            if (index === 4) return '4️⃣';
            if (index === 5) return '5️⃣';
            if (index === 6) return '6️⃣';
            if (index === 7) return '7️⃣';
            if (index === 8) return '8️⃣';
            if (index === 9) return '9️⃣';
            if (index === 10) return '🔟';
        },
        parseIndex(variableId) {
            if (variableId === '1️⃣') return '{{1}}';
            if (variableId === '2️⃣') return '{{2}}';
            if (variableId === '3️⃣') return '{{3}}';
            if (variableId === '4️⃣') return '{{4}}';
            if (variableId === '5️⃣') return '{{5}}';
            if (variableId === '6️⃣') return '{{6}}';
            if (variableId === '7️⃣') return '{{7}}';
            if (variableId === '8️⃣') return '{{8}}';
            if (variableId === '9️⃣') return '{{9}}';
            if (variableId === '🔟') return '{{10}}';
        },
        parseStatus(status) {
            switch (status) {
                case 'APPROVED': return '🟢 Aprovado';
                case 'PENDING': return '🟠 Pendente';
                case 'REJECTED': return '🔴 Rejeitado';
                default: return 'Sem status definido';
            }
        },
        parseCategory(category) {
            switch (category) {
                case 'AUTHENTICATION': return '🔐 Autenticação';
                case 'MARKETING': return '📈 Marketing';
                case 'UTILITY': return '🔧 Utilidade';
                default: return 'Sem categoria definida';
            }
        },
        writingText(value) {
            this.oldText = value.html;
            this.oldRawText = value.text;
            if (this.variables.length) {
                this.variables.map(el => {
                    if (el.id && el.text !== '') {
                        value.html = value.html.replace(el.id, el.text);
                    }
                });
            }
            this.bodyText = value.html;
        },
        buildDbPayload(templateId, templateName) {
            const format = this.templateHeader.format || '';
            const headerType = format !== '' ? format : 'NONE';
            const filename = format === 'DOCUMENT' && this.uploadedFile ? this.uploadedFile.name : null;
            return {
                template_id: templateId,
                template_name: templateName,
                queues_ids: this.selectedTemplate.queues?.length ? this.selectedTemplate.queues : null,
                template_type: this.selectedTemplate.templateType || 'GERAL',
                header_type: headerType,
                filename: filename,
                updated_by: null,
                updated_at: null,
            };
        },
        async saveLocalSettings() {
            this.loading = true;
            const dbPayload = this.buildDbPayload(this.selectedTemplate.id, this.selectedTemplate.name);
            dbPayload.updated_by = parseInt(user.getId());
            await axios.post('/saveTemplates', { templates: [dbPayload] })
                .then(() => {
                    Swal.fire({
                        title: 'Configurações salvas!',
                        text: 'Filas e tipo do template atualizados sem reenvio para a Meta.',
                        type: 'success',
                        toast: true,
                        timer: 3000,
                        showConfirmButton: false,
                        position: 'top-end'
                    });
                    this.getTemplates();
                })
                .catch(e => {
                    console.error(e);
                    Swal.fire({ title: 'Erro ao salvar configurações', type: 'error', showConfirmButton: true });
                })
                .finally(() => { this.loading = false; });
        },
        async createTemplate() {
            if (!this.validateForm()) return;
            Swal.fire({
                title: 'Criação de template',
                text: 'Seu template estará sujeito a aprovação da plataforma Meta. Esta aprovação poderá demorar até 48 horas. Deseja continuar?',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Cancelar',
                type: "warning",
                showCloseButton: true
            }).then(async result => {
                if (result.value) {
                    this.loading = true;
                    let bodyObj = {
                        type: 'BODY',
                        text: this.oldText.replace(/\n$/, '').replace(/(🔟|9️⃣|8️⃣|7️⃣|6️⃣|5️⃣|4️⃣|3️⃣|2️⃣|1️⃣)/g, this.parseIndex),
                    };
                    bodyObj.text = bodyObj.text
                        .replace(/<p>/g, '')
                        .replace(/<\/p>/g, '')
                        .replace(/<br\/>/g, "\n");
                    let templateName = this.selectedTemplate.name.toLowerCase();
                    templateName = templateName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                    templateName = templateName.replace(/\s+/g, "_");
                    templateName = templateName.replace(/[^a-z0-9_]/g, "");
                    if (this.variables.length) {
                        bodyObj.example = { body_text: [this.variables.map(el => el.text)] };
                    }
                    let template = {
                        name: templateName,
                        language: this.selectedTemplate.language,
                        category: this.selectedTemplate.category,
                        content: []
                    };
                    if (this.templateHeader.format === 'TEXT') {
                        template.content.push({ type: 'HEADER', format: 'TEXT', text: this.templateHeader.text });
                    }
                    template.content.push(bodyObj);
                    if (this.templateButtons.length) {
                        const validButtons = this.templateButtons.filter(b => b.text.trim() !== '');
                        if (validButtons.length) {
                            template.content.push({
                                type: 'BUTTONS',
                                buttons: validButtons.map(b => ({ type: 'QUICK_REPLY', text: b.text.trim() }))
                            });
                        }
                    }
                    axios.post(`https://api.advancemanagement.com.br:${process.env.MIX_WEBHOOK_PORT}/create_template`, template).then(async ({ data }) => {
                        if (!data.status || data.status !== 'error') {
                            template.id = data.id;
                            const dbPayload = this.buildDbPayload(data.id, templateName);
                            await axios.post('/saveTemplates', { templates: [dbPayload] }).catch(e => console.error(e));
                            Swal.fire({ title: 'Template criado com sucesso!', type: "success", toast: true, timer: 3000, showConfirmButton: false, position: 'top-end' });
                            await this.getTemplates();
                            this.createNewTemplate();
                            this.loading = false;
                        } else {
                            this.loading = false;
                            Swal.fire({ title: 'Erro ao criar template', html: data.error.error.error_user_msg ? data.error.error.error_user_msg : data.error.error.message, type: "error", showConfirmButton: true });
                        }
                    });
                }
            });
        },
        async editTemplate() {
            if (!this.validateForm()) return;
            Swal.fire({
                title: 'Edição de template',
                text: 'Seu template estará sujeito a aprovação da plataforma Meta. Esta aprovação poderá demorar até 48 horas. Deseja continuar?',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Cancelar',
                type: "warning",
                showCloseButton: true
            }).then(async result => {
                if (result.value) {
                    this.loading = true;
                    let bodyObj = {
                        type: 'BODY',
                        text: this.oldText.replace(/\n$/, '').replace(/(🔟|9️⃣|8️⃣|7️⃣|6️⃣|5️⃣|4️⃣|3️⃣|2️⃣|1️⃣)/g, this.parseIndex),
                    };
                    bodyObj.text = bodyObj.text
                        .replace(/<p>/g, '')
                        .replace(/<\/p>/g, '')
                        .replace(/<br\/>/g, "\n");
                    if (this.variables.length) {
                        bodyObj.example = { body_text: [this.variables.map(el => el.text)] };
                    }
                    let template = {
                        template_id: this.selectedTemplate.id,
                        template_name: this.selectedTemplate.name,
                        content: []
                    };
                    if (this.templateHeader.format === 'TEXT') {
                        template.content.push({ type: 'HEADER', format: 'TEXT', text: this.templateHeader.text });
                    }
                    template.content.push(bodyObj);
                    if (this.templateButtons.length) {
                        const validButtons = this.templateButtons.filter(b => b.text.trim() !== '');
                        if (validButtons.length) {
                            template.content.push({
                                type: 'BUTTONS',
                                buttons: validButtons.map(b => ({ type: 'QUICK_REPLY', text: b.text.trim() }))
                            });
                        }
                    }
                    axios.put(`https://api.advancemanagement.com.br:${process.env.MIX_WEBHOOK_PORT}/edit_template`, template).then(async ({ data }) => {
                        if (!data.status || data.status !== 'error') {
                            const dbPayload = this.buildDbPayload(this.selectedTemplate.id, this.selectedTemplate.name);
                            dbPayload.updated_by = parseInt(user.getId());
                            await axios.post('/saveTemplates', { templates: [dbPayload] }).catch(e => console.error(e));
                            Swal.fire({ title: 'Template editado com sucesso!', type: "success", toast: true, timer: 3000, showConfirmButton: false, position: 'top-end' });
                            await this.getTemplates();
                            this.createNewTemplate();
                            this.loading = false;
                        } else {
                            this.loading = false;
                            Swal.fire({ title: 'Erro ao editar template', html: data.error.error.error_user_msg ? data.error.error.error_user_msg : data.error.error.message, type: "error", showConfirmButton: true });
                        }
                    });
                }
            });
        },
        deleteTemplate() {
            Swal.fire({
                title: 'Exclusão de template',
                text: 'Tem certeza que deseja excluir este template? Esta ação não poderá ser desfeita, e o nome deste template não poderá ser utilizado novamente.',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Cancelar',
                type: "warning",
                showCloseButton: true
            }).then(result => {
                if (result.value) {
                    this.loading = true;
                    const template = {
                        template_id: this.selectedTemplate.id,
                        template_name: this.selectedTemplate.name
                    };
                    axios.post(`https://api.advancemanagement.com.br:${process.env.MIX_WEBHOOK_PORT}/delete_template/`, template).then(async ({ data }) => {
                        if (!data.status || data.status !== 'error') {
                            Swal.fire({ title: 'Template excluído com sucesso!', type: "success", toast: true, timer: 3000, showConfirmButton: false, position: 'top-end' });
                            await this.removeTemplate(template.template_id);
                            await this.getTemplates();
                            this.createNewTemplate();
                            this.loading = false;
                        } else {
                            this.loading = false;
                            Swal.fire({ title: 'Erro ao excluir template', html: data.error.error.error_user_msg ? data.error.error.error_user_msg : data.error.error.message, type: "error", showConfirmButton: true });
                        }
                    });
                }
            });
        },
        getTemplateInfo(templateId) {
            this.rejectionReason = '';
            axios.get(`https://api.advancemanagement.com.br:${process.env.MIX_WEBHOOK_PORT}/get_template_info/`, { params: { template_id: templateId } }).then(({ data }) => {
                if (!data.status || data.status !== 'error') {
                    if (data.rejected_reason) {
                        if (data.rejected_reason === 'ABUSIVE_CONTENT') this.rejectionReason = 'Conteúdo abusivo';
                        if (data.rejected_reason === 'INVALID_FORMAT') this.rejectionReason = 'Formato inválido';
                        if (data.rejected_reason === 'NONE') this.rejectionReason = 'Não informado';
                        if (data.rejected_reason === 'PROMOTIONAL') this.rejectionReason = 'Promocional';
                        if (data.rejected_reason === 'TAG_CONTENT_MISMATCH') this.rejectionReason = 'Categoria incorreta';
                        if (data.rejected_reason === 'SCAM') this.rejectionReason = 'Conteúdo suspeito';
                    }
                }
            });
        },
        async processTemplates(templatesArray, saving = false) {
            const templatesPayload = [];
            templatesArray.map(template => {
                let id;
                if (template.id) id = template.id;
                if (template.template_id) id = template.template_id;
                const dbFind = this.dbTemplates.find((el) => el.template_id === id);
                const templateObj = {
                    template_id: id,
                    template_name: template.name || template.template_name,
                    filename: null,
                    queues_ids: null,
                    template_type: 'GERAL',
                    updated_by: null,
                    updated_at: null
                };

                if (!saving) {
                    if (dbFind) {
                        if (dbFind.queues_ids) templateObj.queues_ids = JSON.parse(dbFind.queues_ids);
                        templateObj.template_type = dbFind.template_type || 'GERAL';
                        templateObj.updated_by = dbFind.updated_by;
                        templateObj.updated_at = dbFind.updated_at;
                    }
                    if (template.components?.length) {
                        const headerIndex = template.components.findIndex(el => el.type === 'HEADER');
                        if (headerIndex > -1) {
                            const type = template.components[headerIndex].format;
                            templateObj.header_type = type;
                            if (dbFind) {
                                if (type === 'DOCUMENT') {
                                    templateObj.filename = dbFind.filename ? dbFind.filename : `${template.id}.pdf`;
                                }
                            } else {
                                if (type === 'DOCUMENT') templateObj.filename = `${template.id}.pdf`;
                            }
                        } else {
                            templateObj.header_type = 'NONE';
                        }
                    }
                } else {
                    templateObj.updated_by = parseInt(user.getId());
                    templateObj.template_type = this.selectedTemplate.templateType || 'GERAL';
                    if (this.selectedTemplate.queues.length) templateObj.queues_ids = this.selectedTemplate.queues;
                    if (template.content?.length) {
                        const headerIndex = template.content.findIndex(el => el.type === 'HEADER');
                        if (headerIndex > -1) {
                            const type = template.content[headerIndex].format;
                            templateObj.header_type = type;
                            if (type === 'DOCUMENT') templateObj.filename = this.uploadedFile ? this.uploadedFile.name : null;
                        } else {
                            templateObj.header_type = 'NONE';
                        }
                    }
                }

                templatesPayload.push(templateObj);
            });

            if (templatesPayload.length) {
                await axios.post('/saveTemplates', { templates: templatesPayload }).catch(error => console.error(error));
            }
        },
        async removeTemplate(templateId) {
            axios.delete('/removeTemplate', { data: { template_id: templateId } }).catch(error => console.error(error));
        },
    },
    watch: {
        'variables': {
            handler(newVal) {
                if (newVal.length) {
                    let newText = this.oldText;
                    newVal.map(el => {
                        if (el.id && el.text !== '') {
                            newText = newText.replace(el.id, el.text);
                            this.bodyText = newText;
                        }
                    });
                }
            },
            deep: true
        },
        'templateHeader.format': {
            handler(newVal) {
                if (newVal === 'TEXT') { this.templateHeader.media = ''; this.headerMedia = null; this.uploadedFile = null; }
                if (newVal === '') { this.templateHeader.text = ''; this.templateHeader.media = ''; this.headerMedia = null; this.uploadedFile = null; }
            },
            deep: true
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';

.module-container {
    display: flex;
    gap: 20px;
    margin: 20px;
    max-height: 100%;
    max-width: 100%;
}

.selected {
    background-color: rgba(lightgray, 0.6) !important;
}

.templates-list {
    flex: 2;
    border: 1px solid lightgray;
    display: flex;
    border-radius: 7px;
    flex-direction: column;
    background-color: white;
    box-shadow: 1px 1px 6px 0px lightgray;
    gap: 5px;
    padding: 10px;
    max-height: 85vh;
    overflow: auto;

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 20px;
        font-weight: bold;
        padding: 10px;
        white-space: nowrap;
        gap: 10px;

        button {
            border-radius: 10px !important;
        }
    }

    &__item {
        padding: 20px;
        border: 1px solid lightgray;
        border-radius: 5px;
        background-color: rgba(lightgray, 0.3);
        cursor: pointer;
        transition: 0.3s;
        display: flex;
        flex-direction: column;
        box-shadow: 1px 1px 6px 0px lightgray;

        &:hover {
            background-color: rgba(lightgray, 0.5);
        }

        .item-name {
            font-size: 20px;
            font-weight: 600;
        }

        .item-category {
            font-size: 16px;
            font-weight: 500;
            color: gray;
        }
    }
}

.template-preview {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 2;
    border: 2px solid lightgray;
    border-radius: 7px;
    height: 85vh;
    max-height: 85vh;
    padding: 10px;
    background-color: white;
    box-shadow: 1px 1px 6px 0px lightgray;

    &__content {
        max-height: 100%;
        overflow-y: auto;
        padding: 10px;
    }

    &__id {
        font-size: 20px;
        font-weight: bold;
    }

    &__section {
        display: flex;
        flex-direction: column;
        gap: 5px;
        margin: 15px 0;

        span {
            font-weight: bold;
        }

        label {
            color: gray;
            margin: 0;
        }

        .variables-container {
            margin: 10px 0;

            .variable-item {
                display: flex;
                gap: 10px;
                align-items: center;

                span {
                    font-size: large;
                }

                button {
                    border-radius: 10px !important;
                }
            }
        }

        .template-info {
            display: flex;
            gap: 20px;
            align-items: center;
        }

        .template-header {
            display: flex;
            gap: 20px;
            align-items: center;

            input {
                flex: 1;
            }

            select {
                flex: 2;
            }
        }
    }
}

/* Tipo do template */
.template-type-selector {
    display: flex;
    gap: 8px;
    margin-top: 4px;
}

.type-option {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 7px;
    padding: 7px 14px;
    border: 2px solid #dee2e6;
    border-radius: 8px;
    cursor: pointer;
    transition: border-color 0.2s, background-color 0.2s, color 0.2s;
    background-color: #fff;
    color: #495057;
    user-select: none;
    white-space: nowrap;

    i {
        font-size: 13px;
    }

    span {
        font-size: 13px;
        font-weight: 600;
    }

    &:hover:not(.type-option--disabled) {
        border-color: #80bdff;
        background-color: #f0f7ff;
    }

    &--active {
        border-color: #007bff;
        background-color: #e8f0fe;
        color: #0056b3;
    }

    &--disabled {
        opacity: 0.55;
        cursor: not-allowed;
    }
}

.template-message-preview {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    border: 2px solid lightgray;
    border-radius: 7px;
    height: 85vh;
    max-height: 85vh;
    padding: 10px;
    background-color: white;
    box-shadow: 1px 1px 6px 0px lightgray;

    &__header {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 20px;
        font-weight: bold;
        padding: 10px;

        button {
            border-radius: 10px !important;
        }
    }

    .preview-slot {
        background-image: url('/images/background-wpp.png');
        background-color: #263b47;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        height: 100%;
        width: 100%;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;

        .message-item {
            background-color: #037963;
            color: white;
            border-radius: 10px;
            margin: 10px;
            padding: 10px;
            display: flex;
            flex-direction: column;
            gap: 10px;

            .message-header {
                font-size: 14px;
                font-weight: bold;
            }

            .message-body {
                font-size: 12px;
                font-weight: 500;

                .body-preview-text :deep(p) {
                    margin: 0 !important;
                }
            }
        }
    }
}

.action-buttons {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    padding: 10px;

    button {
        border-radius: 10px !important;
    }
}

.status {
    display: flex;
    gap: 5px;
    white-space: nowrap;
    font-weight: 600;
}

.approved {
    color: green;
}

.pending {
    color: orange;
}

.rejected {
    color: red;
}

.input-empty {
    border-color: red;
}

/* Badges */
.badges-container {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-top: 6px;
    align-items: center;
}

.queue-badge {
    background-color: #1c869a;
    color: white;
    font-weight: bold;
}

.type-badge {
    font-weight: bold;

    &--geral {
        background-color: #6c757d;
        color: white;
    }

    &--campanha {
        background-color: #e67e22;
        color: white;
    }
}

.tooltip-container {
    position: relative;
    cursor: pointer;
}

.tooltip-text {
    visibility: hidden;
    background-color: #555;
    color: #fff;
    text-align: left;
    border-radius: 5px;
    padding: 5px;
    position: absolute;
    z-index: 1;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 0.3s;
    width: max-content;
    white-space: pre-line;
    margin-top: 5px;
}

.tooltip-item {
    margin: 0;
    padding: 0;
    line-height: 0.7;
}

.tooltip-container:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}

/* Botões quick reply */
.btn-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;

    .btn-index {
        font-size: 13px;
        font-weight: 600;
        color: #6c757d;
        min-width: 18px;
        text-align: right;
    }

    .form-control {
        flex: 1;
        height: 38px;
        font-size: 14px;
        border-radius: 6px !important;
    }

    .btn {
        border-radius: 6px !important;
        height: 38px;
        width: 38px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }
}

.btn-add-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
    height: 36px;
    font-size: 13px;
    font-weight: 500;
    color: #495057;
    background: #fff;
    border: 1.5px dashed #ced4da;
    border-radius: 6px !important;
    cursor: pointer;
    transition: border-color .15s, color .15s;
    margin-top: 4px;

    &:hover:not(:disabled) {
        border-color: #80bdff;
        color: #007bff;
        background: #f8f9ff;
    }

    &:disabled {
        opacity: .5;
        cursor: not-allowed;
    }
}

.message-buttons {
    display: flex;
    flex-direction: column;
    gap: 4px;
    border-top: 1px solid rgba(255, 255, 255, 0.3);
    padding-top: 8px;
    margin-top: 4px;
}

.message-button-item {
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    padding: 5px 8px;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 0.15);
    color: white;
    cursor: default;
}

#loading-modal {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -9999;

    .modal-dialog {
        background-color: white;
        padding: 20px;
        border-radius: 10px;
        max-width: unset;

        .modal-content {
            border: none;

            .modal-body {
                line-height: 3;
                display: flex;
                gap: 16px;
                align-items: center;

                span {
                    font-weight: bold;
                }
            }
        }
    }
}

.modal-showing {
    opacity: 1;
    z-index: 9999 !important;
}

.body-char-counter {
    font-size: 12px;
    color: #6c757d;
    padding: 5px 8px;
    border-radius: 5px;
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    display: flex;
    align-items: center;
    gap: 6px;

    &--warn {
        background: #fff3cd;
        border-color: #ffc107;
        color: #856404;
    }
}
</style>